import { get, post, put, del } from '@/utils/request'
import { withTwoFactor, type TwoFactorOptions } from '@/utils/twoFactor'
import type {
  MenuItem,
  MenuListItem,
  CreateMenuRequest,
  UpdateMenuRequest,
  MenuListParams,
} from '@/types/menu'

export function getMenuTree(): Promise<MenuItem[]> {
  return get<MenuItem[]>('/admin/v1/menus')
}

export function getMenuList(
  params: MenuListParams
): Promise<{ items: MenuListItem[]; total: number }> {
  return get<{ items: MenuListItem[]; total: number }>('/admin/v1/menus/flat', params)
}

export function getMenuDetail(id: string): Promise<MenuListItem> {
  return get<MenuListItem>(`/admin/v1/menus/${id}`)
}

export function createMenu(data: CreateMenuRequest, options?: TwoFactorOptions): Promise<void> {
  return post<void>('/admin/v1/menus', data, withTwoFactor(options))
}

export function updateMenu(
  id: string,
  data: UpdateMenuRequest,
  options?: TwoFactorOptions
): Promise<void> {
  return put<void>(`/admin/v1/menus/${id}`, data, withTwoFactor(options))
}

export function deleteMenu(id: string, options?: TwoFactorOptions): Promise<void> {
  return del<void>(`/admin/v1/menus/${id}`, undefined, withTwoFactor(options))
}
